export const GET_HISTORICAL_DATA_REQUEST = 'GET_HISTORICAL_DATA_REQUEST';
export const GET_HISTORICAL_DATA_SUCCESS = 'GET_HISTORICAL_DATA_SUCCESS';
export const GET_HISTORICAL_DATA_ERROR = 'GET_HISTORICAL_DATA_ERROR';

export const GET_HISTORICAL_MACHINES_REQUEST =
  'GET_HISTORICAL_MACHINES_REQUEST';
export const GET_HISTORICAL_MACHINES_SUCCESS =
  'GET_HISTORICAL_MACHINES_SUCCESS';
export const GET_HISTORICAL_MACHINES_ERROR = 'GET_HISTORICAL_MACHINES_ERROR';

export const GET_MACHINE_SHIFTS_REQUEST = 'GET_MACHINE_SHIFTS_REQUEST';
export const GET_MACHINE_SHIFTS_SUCCESS = 'GET_MACHINE_SHIFTS_SUCCESS';
export const GET_MACHINE_SHIFTS_ERROR = 'GET_MACHINE_SHIFTS_ERROR';
